import React, { useState } from "react";
import "./mtp.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";

export default function Mtp(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState("");

  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setFormData({
            ...formData,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: "Not Visited",
          notes: "Booking Visit",
          patient_id: patientId,
        });
      }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value) => {
    return (
      <td style={{ border: "1px solid black", textAlign: "center" }}>
        {value}
      </td>
    );
  };
  const renderTableTH = (value) => {
    return (
      <th style={{ border: "1px solid black", textAlign: "center" }}>
        {value}
      </th>
    );
  };
  const handlesubmit = () => {
    props.loaderchange("false");

    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        props.patientsData.p_uhid.length === 10
      ) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "mtpReportGenerateWrap"
          ).innerHTML;

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();
          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "MTP",
            },
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div id="Mtp">
      <div className="Mtp">
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px"

            }}
          > */}
          {/* Patient ID and Couple ID (Side by side) */}
          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={formData.patientId1}
                  onChange={(e) => handleChange(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.patientId1}
                </span>
              </div>
            </div> */}

          {/* Patient Name */}
          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{formData.patientName1}
              </span>
            </div> */}
          {/* Gender and Blood Group (Side by side) */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={formData.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={formData.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.age1}
              </span>
            </div> */}

          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center",
                // paddingLeft: "25px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Blood Group</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <select
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                name="bloodGroup1"
                value={formData.bloodGroup1}
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  backgroundColor: "white",
                }}
              >
                <option value="" disabled selected>
                  Select Blood Group
                </option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.bloodGroup1}
              </span>
            </div> */}
          {/* </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
        </div>
        <div className="detail">
          <h2>MTP</h2>
          <p>FORM 1 / FORM C if Unexpected pregnancy</p>
          <p>
            Indication:{" "}
            <select name="indication" onChange={handleChange}>
              <option value="" disabled selected>
                Plese Select
              </option>
              <option value="Unexpected">Unexpected</option>
              <option value="Missed miscarriage">Missed miscarriage</option>
              <option value="Incomplete miscarriage">
                Incomplete miscarriage
              </option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{formData.indication}
            </span>
          </p>
        </div>
        <div className="bulletin">
          <ul>
            <li>To get admitted / wants home monitoring</li>
          </ul>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>Sno</th>
              <th>Drug</th>
              <th>Dosage</th>
              <th>Frequency</th>
              <th>Route</th>
              <th>Days</th>
            </tr>
            <tr>
              <td>1</td>
              <td>Tab. MIFEPRISTONE</td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="mifepristone_dosage"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.mifepristone_dosage}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="mifepristone_frequency"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.mifepristone_frequency}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="mifepristone_route"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.mifepristone_route}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="mifepristone_days"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.mifepristone_days}
                </span>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>NO TAB NEXT DAY</td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="no_tab_next_day_dosage"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.no_tab_next_day}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="no_tab_next_day_frequency"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.no_tab_next_day_frequency}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="no_tab_next_day_route"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.no_tab_next_day_route}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="no_tab_next_day_days"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.no_tab_next_day_days}
                </span>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>TAB. MISOPROSTOL</td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="misoprostol_dosage"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.misoprostol_dosage}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="misoprostol_frequency"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.misoprostol_frequency}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="misoprostol_route"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.misoprostol_route}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="misoprostol_days"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.misoprostol_days}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="bulletin">
          <ul>
            <li>At hospital</li>
            <li>Inj. Taxim 1G IV ATD ; inj. Para 1 gm SOS</li>
            <li>At home</li>
            <li>Tab. Taxim O 200 mg 1-0-1*3 days from</li>
            <li>Tab. Pan 40 mg 1-0-1*3 days</li>
            <li>Tab. Ultracet 1 tab SOS</li>
            <li>Tab.trapic MF 1 SOS if bleeding is heavy</li>
            <li>
              if bleeding is heavy reach{" "}
              <input
                className={`createTime ${show ? "hide" : "show"}`}
                name="hospital_reach"
                onChange={handleChange}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{formData.hospital_reach}
              </span>
              hospital
            </li>
          </ul>
        </div>
        <div className="detail">
          <p>Investigations</p>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>CBC</th>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="cbc"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.cbc}
                </span>
              </td>
            </tr>
            <tr>
              <th>BLOOD GROUP</th>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="bloodgroup"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.bloodgroup}
                </span>
              </td>
            </tr>
            <tr>
              <th>TSH</th>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="tsh"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.tsh}
                </span>
              </td>
            </tr>
            <tr>
              <th>HIV HBSAG HCV</th>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="hivhbsaghcv"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.hivhbsaghcv}
                </span>
              </td>
            </tr>
            <tr>
              <th>RBS,HBA1C</th>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="rbshba1c"
                  onChange={handleChange}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{formData.rbshba1c}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <p style={{ fontWeight: "600" }}>
          NEXT APPOINTMENT -{" "}
          <input
            name="nextappointment"
            onChange={handleChange}
            type="datetime-local"
            // type="date"
          />
        </p>
        <div className={`Footer ${show ? "hide" : "show"}`}>
          <button onClick={handlesubmit} className="Button_Create">
            Add Report
          </button>
        </div>
      </div>
      <div id="mtpReportGenerate">
        <div id="mtpReportGenerateWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>MTP</h4>
          </div>
          <h4>FORM 1 / FORM C if Unexpected pregnancy</h4>
          <p class="Dani"></p>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Indication :", formData.indication)}
          </div>
          <div
            style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}
          >
            <span>●</span>
            <p style={{ marginLeft: "5px" }}>
              To get admitted / wants home monitoring
            </p>
          </div>
          <div>
            <table>
              <thead>
                <tr>
                  {["Sno", "Drug", "Dosage", "Frequency", "Route", "Days"].map(
                    (ele) => renderTableTH(ele)
                  )}
                </tr>
              </thead>
              <tbody>
                {[...Array(3)].map((_, i) => {
                  const drug = [
                    "Tab. MIFEPRISTONE",
                    "NO TAB NEXT DAY",
                    "TAB. MISOPROSTOL",
                  ];
                  const th = ["dosage", "frequency", "route", "days"];
                  const tval = [
                    "mifepristone_",
                    "no_tab_next_day_",
                    "misoprostol_",
                  ];
                  return (
                    <tr key={i}>
                      {renderTableTD(i + 1)}
                      {renderTableTD(drug[i])}
                      {th.map((ele, ind) =>
                        renderTableTD(formData[`${tval[i]}${ele}`])
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {[
            "At hospital",
            "Inj. Taxim 1G IV ATD ; inj. Para 1 gm SOS",
            "At home",
            "Tab. Taxim O 200 mg 1-0-1*3 days from",
            "Tab. Pan 40 mg 1-0-1*3 days",
            "Tab. Ultracet 1 tab SOS",
            "Tab.trapic MF 1 SOS if bleeding is heavy",
          ].map((ele) => (
            <div
              style={{
                display: "flex",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <span>●</span>
              <p style={{ marginLeft: "5px" }}>{ele}</p>
            </div>
          ))}
          <div
            style={{
              display: "flex",
              marginBottom: "10px",
              marginTop: "10px",
            }}
          >
            <span>●</span>
            <p style={{ marginLeft: "5px", marginRight: "5px" }}>
              If bleeding is heavy reach{" "}
            </p>
            <span> {formData.hospital_reach} hospital</span>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>
              Investigations
            </h4>
          </div>
          <div>
            <table>
              <tbody>
                {[
                  "CBC",
                  "BLOOD GROUP",
                  "TSH",
                  "HIV HBSAG HCV",
                  "RBS,HBA1C",
                ].map((ele, ind) => {
                  const val = [
                    "cbc",
                    "bloodgroup",
                    "tsh",
                    "hivhbsaghcv",
                    "rbshba1c",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTH(ele)}
                      {renderTableTD(formData[val[ind]])}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>
            {renderReportfield(
              "Next Appointment : ",
              appointmentData.date?.split("-").reverse().join("-")
            )}
          </div>
          <p class="Dani"></p>
        <PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
